export default __webpack_public_path__ + "static/media/default.e366a2666f08a51ed492b579a707cd56.png";